export const DEFAULT_OBJECT_STATE: any = {
  data: undefined,
  meta: {
    count: 0,
  },
  loading: false,
  error: null,
}
